"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
/* eslint-disable */
var _default = function _default() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "74",
    height: "18",
    viewBox: "0 0 74 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M54.799 17.6832H0C7.13278 16.3124 54.456 16.1068 54.456 16.1068C65.4295 15.9012 73.5225 10.2124 73.5225 10.2124C73.5225 10.2124 68.7216 17.5461 54.799 17.6832Z",
    fill: "#EE3224"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.925 1.16512C25.925 0.616801 26.3365 0.205566 26.8852 0.205566H30.7945C32.1662 0.205566 33.2636 0.616801 33.9494 1.30219C34.4981 1.91905 34.841 2.74152 34.841 3.63253C34.841 5.41455 33.8122 6.44264 32.372 6.92242L34.4981 9.52691C34.7039 9.73253 34.841 9.93815 34.841 10.2808C34.841 10.8292 34.3609 11.1719 33.9494 11.1719C33.5379 11.1719 33.2636 10.9662 32.9892 10.6921L30.3144 7.33365H27.914V10.2808C27.914 10.8292 27.5025 11.2404 26.9538 11.2404C26.4051 11.2404 25.9936 10.8292 25.9936 10.2808V1.16512H25.925ZM30.6574 5.62017C32.029 5.62017 32.9206 4.93478 32.9206 3.76961C32.9206 2.60444 32.0976 1.98759 30.6574 1.98759H27.8454V5.68871H30.6574V5.62017Z",
    fill: "#EE3224"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37.2415 10.1438V1.16512C37.2415 0.616801 37.6529 0.205566 38.2016 0.205566H44.58C45.0601 0.205566 45.4716 0.616802 45.4716 1.09658C45.4716 1.57635 45.0601 1.98759 44.58 1.98759H39.1618V4.7977H43.8941C44.3742 4.7977 44.7858 5.20894 44.7858 5.68871C44.7858 6.16849 44.3742 6.51118 43.8941 6.51118H39.1618V9.45837H44.6486C45.1287 9.45837 45.5402 9.86961 45.5402 10.3494C45.5402 10.8292 45.1287 11.2404 44.6486 11.2404H38.2016C37.6529 11.1033 37.2415 10.6921 37.2415 10.1438Z",
    fill: "#EE3224"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.7349 1.16512C47.7349 0.616801 48.1463 0.205566 48.695 0.205566H51.7813C55.2105 0.205566 57.611 2.5359 57.611 5.62017C57.611 8.70444 55.2105 11.1033 51.7813 11.1033H48.695C48.1463 11.1033 47.7349 10.6921 47.7349 10.1438V1.16512ZM51.7813 9.32129C54.0446 9.32129 55.5534 7.74489 55.5534 5.62017C55.5534 3.49545 54.0446 1.91905 51.7813 1.91905H49.6552V9.32129H51.7813Z",
    fill: "#EE3224"
  }));
};
exports.default = _default;